import { NavLink, useInRouterContext, useLocation } from 'react-router-dom';
import { Cog, LogOut } from 'lucide-react';

const WORKFLOW_NAV_ITEMS = [
  { to: '/kiosk', label: 'ชั่งน้ำหนัก' },
  { to: '/tpn-bookings', label: 'ใบจอง' },
  { to: '/pallet-registrations', label: 'พาเลท' },
];

function RouterWorkflowNav({ showLogout, logoutHref, logoutLabel }) {
  const { pathname } = useLocation();

  return (
    <nav className="workflow-nav" aria-label="Workflow navigation">
      {WORKFLOW_NAV_ITEMS.map((item) => {
        const isIndexKiosk = pathname === '/' && item.to === '/kiosk';

        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `workflow-nav-link${isActive || isIndexKiosk ? ' active' : ''}`}
          >
            {item.label}
          </NavLink>
        );
      })}
      <NavLink to="/register-bindings" className="workflow-nav-icon-link">
        <Cog size={20} />
      </NavLink>
      {showLogout ? (
        <a
          href={logoutHref}
          className="workflow-nav-icon-link workflow-nav-logout-icon-link"
          aria-label={logoutLabel}
          title={logoutLabel}
        >
          <LogOut size={20} />
        </a>
      ) : null}
    </nav>
  );
}

function StaticWorkflowNav({ showLogout, logoutHref, logoutLabel }) {
  const pathname = typeof window === 'undefined' ? '' : window.location.pathname;

  return (
    <nav className="workflow-nav" aria-label="Workflow navigation">
      {WORKFLOW_NAV_ITEMS.map((item) => {
        const isActive = pathname === item.to || (pathname === '/' && item.to === '/kiosk');

        return (
          <a
            key={item.to}
            href={item.to}
            className={`workflow-nav-link${isActive ? ' active' : ''}`}
          >
            {item.label}
          </a>
        );
      })}
      <a href="/register-bindings" className="workflow-nav-icon-link">
        <Cog size={20} />
      </a>
      {showLogout ? (
        <a
          href={logoutHref}
          className="workflow-nav-icon-link workflow-nav-logout-icon-link"
          aria-label={logoutLabel}
          title={logoutLabel}
        >
          <LogOut size={20} />
        </a>
      ) : null}
    </nav>
  );
}

export default function WorkflowNav({
  showLogout = true,
  logoutHref = '/api/auth/logout',
  logoutLabel = 'ออกจากระบบ',
}) {
  return useInRouterContext() ? (
    <RouterWorkflowNav showLogout={showLogout} logoutHref={logoutHref} logoutLabel={logoutLabel} />
  ) : (
    <StaticWorkflowNav showLogout={showLogout} logoutHref={logoutHref} logoutLabel={logoutLabel} />
  );
}
